import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserViewService } from 'app/services/user-view.service';
import { UserView } from 'app/models/user-views';

export const activateAdminGuard: CanActivateFn | CanActivateChildFn = async (): Promise<UrlTree | boolean> => {
  const userViewService: UserViewService = inject(UserViewService);
  const redirectPath: UrlTree = inject(Router).createUrlTree(['']);

  const canActivate = await userViewService.canActivateUserView(UserView.ALL_API);

  return canActivate ? true : redirectPath;
};
